<template>
  <div class="mb-4 fhd:my-14 text-gray-700 dark:text-gray-400
      text-li w-11/12 self-center sm:w-2/3 4k:w-full">
    <p class="font-bold text-li fhd:text-xl 4k:text-5xl">{{ 'talksLikes' | lang('education') }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listExtras: this.$options.filters.lang('talksLikes', 'education'),
    };
  },
}
</script>